const screenHeight = () => {
    return window.innerHeight;
};

const isIOSSafari = () => {
    const userAgent = navigator.userAgent;
    return userAgent.indexOf('iPhone') > -1 && userAgent.indexOf('Safari') > -1 && userAgent.indexOf('CriOS') === -1;
};

export const BrowserUtils = {
    isIOSSafari,
    screenHeight,
};
